// Paste kiye hue text me se YouTube links nikaalne wala helper.
// Links kaise bhi paste ho — markdown [url](url), ek hi line me kai links,
// youtu.be / shorts / embed / live, ya extra text ke saath — system khud
// saaf karke short shakal (https://youtu.be/ID) me laata hai
// aur same paste ki duplicate links ek hi baar rakhta hai.

export function ytVideoId(url) {
  const s = String(url || '').trim();
  if (!s) return '';
  let m = s.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  m = s.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  m = s.match(/youtube\.com\/(?:shorts|embed|live|v)\/([a-zA-Z0-9_-]{11})/);
  if (m) return m[1];
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  return '';
}

export function ytNormalize(url) {
  const id = ytVideoId(url);
  return id ? `https://youtu.be/${id}` : String(url || '').trim();
}

export function parseYouTubeLinks(text) {
  const cleaned = String(text || '').replace(/[[\]()<>"',]+/g, ' ');
  const urls = cleaned.match(/https?:\/\/[^\s]+/gi) || [];
  const seen = [];
  const set = new Set();
  urls.forEach(raw => {
    const id = ytVideoId(raw.replace(/[.;:!?]+$/, ''));
    if (!id) return;
    const link = `https://youtu.be/${id}`;
    if (!set.has(link)) { set.add(link); seen.push(link); }
  });
  if (seen.length === 0) {
    (cleaned.match(/\b[a-zA-Z0-9_-]{11}\b/g) || []).forEach(id => {
      const link = `https://youtu.be/${id}`;
      if (!set.has(link)) { set.add(link); seen.push(link); }
    });
  }
  return seen;
}
